module.exports = {"query_editor":{"nav_title":"查询编辑器"}}